export * from './tag'
import { default as tag } from './tag'

export default tag
